<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('bakery orders')"
      :columns="columns"
      :column_search="true"
      resource_url="/bakery_order/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <order-modal ref="order_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import OrderModal from "../order_modal/Index.vue";

export default {
  name: "ProvidersDatatable",
  components: { GenericTable, OrderModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("name"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return `<div class="media-content">
                <div class="title is-5">
                  <span>${row.customer_name}</span>                  
                </div>                
                <div class="subtitle is-6 mb-0" >
                  <span class="icon">
                    <i class="fa fa-at"></i>
                  </span>
                  ${row.customer_email}
                </div>
                <div
                  class="subtitle is-6 mb-0"                  
                >
                  <span class="icon">
                    <i class="fa fa-phone"></i>
                  </span>
                  ${row.customer_phone}
                </div>
                <div class="subtitle is-6 mb-0" >
                  <span class="icon">
                    <i class="fa fa-home"></i>
                  </span>
                  ${row.customer_address}
                </div>                
              </div>`;
          },
        },
        {
          title: v.$t("total"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total || 0);
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.status_code;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/bakery_order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.order_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
